import { render, staticRenderFns } from "./OverviewWillVerification.vue?vue&type=template&id=21b01887&scoped=true"
import script from "./OverviewWillVerification.vue?vue&type=script&lang=js"
export * from "./OverviewWillVerification.vue?vue&type=script&lang=js"
import style0 from "./OverviewWillVerification.vue?vue&type=style&index=0&id=21b01887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b01887",
  null
  
)

export default component.exports